<div [formGroup]="form">
  <p class="text-sm mb-1 text-gray-600">
    {{ 'common.changeLanguage' | translate }}
  </p>
  <p-select
    [options]="languageOptions"
    formControlName="language"
    styleClass="w-full"
  />
</div>
